import * as React from 'react';
import * as PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { isFunction } from '@utiljs/is';
import Link from '../_utils/Link';

var DateCell = function DateCell(props) {
  var handleDate = function handleDate(e) {
    if (props.disabled) {
      return;
    }

    e.stopPropagation();
    props.onSelectDate(props.date.valueOf(), e);
  };

  var handleOver = function handleOver(e) {
    e.stopPropagation();

    if (props.onHover) {
      props.onHover(props.date.valueOf(), e);
    }
  };

  return /*#__PURE__*/React.createElement("td", {
    onClick: handleDate,
    className: props.className,
    onMouseOver: handleOver,
    onFocus: handleOver
  }, props.dateCellRender && isFunction(props.dateCellRender) ? props.dateCellRender(props.dateText, props.date) : /*#__PURE__*/React.createElement(Link, null, props.dateText));
};

DateCell.propTypes = {
  class: PropTypes.string,
  date: PropTypes.object,
  dateText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  onHover: PropTypes.func,
  onSelectDate: PropTypes.func
};
DateCell.defaultProps = {
  class: 'day',
  date: dayjs(),
  dateText: 0,
  disabled: false,
  onHover: function onHover() {},
  onSelectDate: function onSelectDate() {}
};
export default DateCell;